import { useApolloClient } from "@/config/apollo";
import { NewRelicSession } from "@/config/newrelic/NewRelicSession";
import { muiSnackbarConfig } from "@/config/snackbar";
import ProtectedRoute from "@/provider/AuthProvider/ProtectedRoute";
import { ApolloProvider } from "@apollo/client/react";
import { NotificationsProvider } from "@toolpad/core";
import type { ReactNode } from "react";

type AuthenticatedShellProps = {
  children?: ReactNode;
};

export const AuthenticatedShell = (props: AuthenticatedShellProps) => {
  const { children } = props;
  const apolloClient = useApolloClient();

  return (
    <ProtectedRoute>
      <ApolloProvider client={apolloClient}>
        <NotificationsProvider
          slots={{ snackbar: muiSnackbarConfig.slot }}
          slotProps={{ snackbar: muiSnackbarConfig.slotProps }}
        >
          <NewRelicSession />
          {children}
        </NotificationsProvider>
      </ApolloProvider>
    </ProtectedRoute>
  );
};
